export default "__VITE_ASSET__TrzGfZCD__"